<div class="xwai-sidebar" [class.collapsed]="collapsed">
  <div class="sidebar-header">
    <img src="/assets/icons/xwai-icon-cropped.png" alt="XWAI" class="sidebar-logo" />
    <span class="wordmark">XWAI</span>
    <button
      class="collapse-toggle"
      (click)="collapseToggle.emit()"
      nz-tooltip
      [nzTooltipTitle]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      nzTooltipPlacement="right">
      <span nz-icon [nzType]="collapsed ? 'menu-unfold' : 'menu-fold'" nzTheme="outline"></span>
    </button>
  </div>

  <button class="new-chat-btn" (click)="startNewChat()" nz-tooltip
    [nzTooltipTitle]="collapsed ? 'New chat' : ''" nzTooltipPlacement="right">
    <span nz-icon nzType="plus" nzTheme="outline"></span>
    <span class="new-chat-label">New chat</span>
  </button>

  <div class="sidebar-search">
    <span nz-icon nzType="search" nzTheme="outline" class="search-icon"></span>
    <input
      type="text"
      [(ngModel)]="filterText"
      placeholder="Search conversations"
      class="search-input" />
  </div>

  <div class="convo-list">
    <div class="convo-section-label">Saved conversations</div>

    @for (convo_name of filteredConvoNames; track convo_name) {
      <div
        class="convo-row"
        [class.active]="convo_name === activeKey"
        (click)="selectConvo(convo_name)">
        <span nz-icon nzType="message" nzTheme="outline" class="convo-icon"></span>
        @if (editingKey === convo_name) {
          <input
            #editInput
            type="text"
            class="convo-edit-input"
            [(ngModel)]="editTitleValue"
            (click)="$event.stopPropagation()"
            (keydown.enter)="confirmEditConvo(convo_name, $event)"
            (keydown.escape)="cancelEditConvo($event)" />
          <button
            class="convo-edit-confirm"
            (click)="confirmEditConvo(convo_name, $event)"
            nz-tooltip
            nzTooltipTitle="Save title">
            <span nz-icon nzType="check" nzTheme="outline"></span>
          </button>
          <button
            class="convo-edit-cancel"
            (click)="cancelEditConvo($event)"
            nz-tooltip
            nzTooltipTitle="Cancel">
            <span nz-icon nzType="close" nzTheme="outline"></span>
          </button>
        } @else {
          <span class="convo-row-title" nz-tooltip [nzTooltipTitle]="convo_name" nzTooltipPlacement="right">{{ convo_name }}</span>
          <button
            class="convo-edit"
            (click)="startEditConvo(convo_name, $event)"
            nz-tooltip
            nzTooltipTitle="Rename conversation">
            <span nz-icon nzType="edit" nzTheme="outline"></span>
          </button>
          <button
            class="convo-delete"
            nz-popconfirm
            nzPopconfirmTitle="Delete this conversation?"
            nzOkText="Delete"
            nzCancelText="Cancel"
            [nzOkDanger]="true"
            (nzOnConfirm)="deleteConvo(convo_name)"
            (click)="$event.stopPropagation()"
            nz-tooltip
            nzTooltipTitle="Delete conversation">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
        }
      </div>
    }

    @if (filteredConvoNames.length === 0) {
      <div class="convo-empty">
        @if (filterText.trim()) {
          No conversations match "{{ filterText }}"
        } @else {
          No saved conversations yet
        }
      </div>
    }
  </div>
</div>
